module.exports = __webpack_public_path__ + "img/applist-desktop.b7e6026f.jpg";